module.exports = __webpack_public_path__ + "img/img21.9eba5def.png";